export default __webpack_public_path__ + "93f4d4f9709b14f0db75913c9836b7b4.webp";